// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC2F4wcRBiC5qn5NaJNfiASal9jTE9Pcyg",
  authDomain: "napco-tms.firebaseapp.com",
  projectId: "napco-tms",
  storageBucket: "napco-tms.firebasestorage.app",
  messagingSenderId: "385224802160",
  appId: "1:385224802160:web:635a67c5b67707849559b5",
  measurementId: "G-BJT1VMHNMN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { auth, app, analytics };
